import CoreAPIService from '../CoreAPIService';

class PaymentInquiry {
    apiService;

    constructor() {
        this.apiService = new CoreAPIService();
    }


    async getManagementFeeSearch(searchParams) {
        // Handle both old format (string) and new format (object)
        if (typeof searchParams === 'string') {
            // Legacy support - if string is passed, use it as deceasedName
            return this.apiService.get(`/goins/search?goinName=${searchParams}`);
        }

        // New format - object with deceasedName or contractorName
        const queryParams = new URLSearchParams();
        if (searchParams.deceasedName) {
            queryParams.append('goinName', searchParams.deceasedName);
        }
        if (searchParams.contractorName) {
            queryParams.append('customerName', searchParams.contractorName);
        }

        return this.apiService.get(`/fee/unified-search?${queryParams.toString()}`);
    }


  


    async getFeePaymentInfo(data) {
        return this.apiService.get(`/fee/payment-view`, { ...data });
    }

    async getAddressAndPhone(data) {
        return this.apiService.get(`/fee/address`, { ...data });
    }

    async getAddressAndPhoneWithFallback(data) {
        const primaryMode = Number(data?.mode);
        const modeCandidates = primaryMode === 1 ? [1, 2] : primaryMode === 2 ? [2, 1] : [primaryMode];
        const rawNameCandidates = Array.isArray(data?.nameCandidates)
            ? data.nameCandidates
            : [data?.name];
        const nameCandidates = [...new Set(
            rawNameCandidates
                .map((name) => (typeof name === 'string' ? name.trim() : ''))
                .filter(Boolean)
        )];

        let lastError;

        for (const mode of modeCandidates) {
            for (const name of nameCandidates) {
                try {
                    return await this.getAddressAndPhone({
                        mode,
                        name,
                        dob: data?.dob,
                    });
                } catch (error) {
                    lastError = error;
                    if (error?.response?.status !== 404) {
                        throw error;
                    }
                }
            }
        }

        throw lastError;
    }


// ✅ Correct
async getMode2FeeSearch(searchParams) {
  const queryParams = new URLSearchParams();

  if (searchParams?.deceasedName) {
    queryParams.append('deceasedName', searchParams.deceasedName);
  }
  if (searchParams?.enshrineName) {
    queryParams.append('enshrineName', searchParams.enshrineName);
  }

  const url = `fee/search/mode2?${queryParams.toString()}`;
  console.log("🔎 Mode2 API Request:", url);

  return this.apiService.get(url);
}



    // // ✅ Mode2 API: Detail fetch
    // async getFeePaymentInfoByDeceased(params) {
    //     try {
    //         const response = await this.apiService.get('/api/v1/fee/search/mode2', { params });
    //         return response.data;
    //     } catch (error) {
    //         console.error('Error in getFeePaymentInfoByDeceased:', error);
    //         throw error;
    //     }
    // }




}

export default new PaymentInquiry();